import React, {Component} from 'react'
import {Link} from 'react-router-dom'
import Typed from 'react-typed'

import style from './banner.sass'

const typedStrings = [
  'If Bitcoin crosses below Lower Bollinger band and Market sentiment is negative',
  'If Macys store traffic is 20% above last month and RSI is below 75',
  'If close is above 52 week high and SPX 50 day moving average is above 200 day moving average'
]

class BannerContent extends Component {
  render() {
    return(
      <div styleName='container'>
        <div styleName='text'>
          <h3>
            Automated Stock and Crypto Trading
            <span styleName='slogan'>Type in English, Test in Seconds</span>
          </h3>
          <Typed
            strings={typedStrings}
            styleName='typed'
            typeSpeed={40}
            backSpeed={30}
            loop
          />
          <Link to='/signup'>get started for free</Link>
        </div>
        <div styleName='img-container'>
          <img src='/img/landing/home/banner-laptop-new2.png' alt=''/>
        </div>
      </div>
    )
  }
}

export default BannerContent
